import React from 'react';
import './css/project.css';

export default function Projects() {
  return (
    <div className="project" id="project">
      <h1>Portfolio</h1>
      <div className="container portfolio">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-4 mb-4">
              <div className="card">
                <div className="image-scrol">
                  <img
                    src="assets/ecommerce01.png"
                    className="card-img-top"
                    alt="..."
                  />
                </div>
                <div className="card-body">
                  <h5 className="card-title">Small Shopping Cart</h5>
                  <p className="card-text">
                    This project is about an E-commerce. This project fully
                    based on React.js and you can enjoy the UI through click
                    Live_D
                  </p>
                  <a
                    // href="https://github.com/Raihanultomal/E-commerc-useing-React"
                    // href="https://glittery-squirrel-a0f2e8.netlify.app/"
                    href="https://raihanulecommerce01.netlify.app/"
                    rel="noreferrer"
                    target="_blank"
                    className="btn btn-primary"
                  >
                    Live_D <i class="bi bi-box-arrow-up-right"></i>
                  </a>
                </div>
              </div>
            </div>
            <div className="col-md-4 mb-3">
              <div className="card">
                <div className="image-scrol">
                  <img
                    src="assets/portfolio_3.png"
                    className="card-img-top"
                    alt="..."
                  />
                </div>
                <div className="card-body">
                  <h5 className="card-title">Collect Information</h5>
                  <p className="card-text">
                    This project is about MERN stack which have Authentication.
                    User can regester & login here. After loging user can note
                    or collect there information that needed.
                  </p>
                  <a
                    href="https://github.com/Raihanultomal/Collect_Info_With_Authentication_MERN"
                    rel="noreferrer"
                    target="_blank"
                    className="btn btn-primary"
                  >
                    Github <i class="bi bi-box-arrow-up-right"></i>
                  </a>
                </div>
              </div>
            </div>
            <div className=" col-md-4 mb-3">
              <div className="card">
                <div className="image-scrol">
                  <img
                    src="assets/redux_CRUD.png"
                    className="card-img-top"
                    alt="..."
                  />
                </div>
                <div className="card-body">
                  <h5 className="card-title">Redux CRUD App</h5>
                  <p className="card-text">
                    This project structured for redux CRUD operation. This is a
                    very basic project of Redux and react-redux. Please click
                    Live_D to visite the app
                  </p>
                  <a
                    // href="https://github.com/Raihanultomal/Money-management-app"
                    href="https://raihanul-redux-crud.netlify.app/"
                    rel="noreferrer"
                    target="_blank"
                    className="btn btn-primary"
                  >
                    Live_D <i class="bi bi-box-arrow-up-right"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
